<app-dropdown 
    [options]="options" 
    [valueFormControl]="valueFormControl" 
    [fieldPlaceholder]="'export-creation.form.selectCalculationFuncType.placeholder' | translate">
</app-dropdown>
